<div class="modal inmodal fade in create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">Create {{title}}</h4>
                        <div class="input-group-btn pull-right">
                            <button tabindex="-1" class="btn btn-primary submit"
                                    type="submit" [disabled]="disabledSubmit">Save</button>
                            <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle" type="button"
                                    aria-expanded="false"><span class="caret"></span></button>
                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="closeModal()">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <!--  ** Building **  -->
                    <div class="row m-b-xs" [hidden]="inDirectoryItemView || directoryService.buildingsForUpdate.length < 2">
                        <div class="dv-label col-sm-4 strong">Building</div>
                        <div class="dv-value-edit col-sm-8">
                            <select class="form-control" [ngModel]="buildingId" name="building"
                                    (change)="getSuitesByBuildingId($event.target.value)"
                                    required #buildingSelect>
                                <option value="" hidden></option>
                                <option *ngFor="let build of directoryService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>
                            </select>
                        </div>
                    </div>

                    <!--  ** Unit **  -->
                    <div class="row m-b-xs" [hidden]="inDirectoryItemView">
                        <div class="dv-label col-sm-4 strong">Unit</div>
                        <div class="dv-value-edit col-sm-8">
                            <search-select [ngModel]="suiteId" name="suite" required
                                           [data]="suiteToSearchSelect(suites)"></search-select>
                            <spinner [spinnerShow]="buildingSelect.value && !suites.length"></spinner>
                        </div>
                    </div>

                    <!--  ** Parking Number **  -->
                    <div class="row m-b-xs m-t-md">
                        <div class="dv-label col-sm-4 strong">Parking Number</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="parkingNumber" ngModel required maxlength="255">
                        </div>
                    </div>

                    <!--  ** Level **  -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Level</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="level" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--  ** Rented Out **  -->
                    <div class="row m-b-xs m-t-md">
                        <div class="dv-label col-sm-4 strong">Rented Out</div>
                        <div class="dv-value-edit col-sm-8">
                            <select class="form-control" name="rentedOut" [ngModel]="0" #rentedOutSelect>
                                <option [value]="1">Yes</option>
                                <option [value]="0">No</option>
                            </select>
                        </div>
                    </div>

                    <!--** building ** -->
                    <div class="row m-b-xs" *ngIf="rentedOutSelect.value == 1">
                        <div class="dv-label col-sm-4 strong">Building</div>
                        <div class="dv-value-edit col-sm-8">
                            <select class="form-control"
                                    name="rentedToBuilding"
                                    ngModel
                                    (change)="changeBuilding($event.target.value, form)">
                                <option value="" hidden></option>
                                <option *ngFor="let build of directoryService.buildings"
                                        [value]="build.id">{{build.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!--** rentedToSuite ** -->
                    <div class="row m-b-xs" *ngIf="rentedOutSelect.value == 1">
                        <div class="dv-label col-sm-4 strong">Unit</div>
                        <div class="dv-value col-sm-8">
                            <search-select ngModel
                                           name="rentedToSuite"
                                           style="height: 26px;"
                                           (ngModelChange)="changeUnit($event, form)"
                                           [data]="rentedToSuiteToSearchSelect(rentedToSuites)">
                            </search-select>
                            <input *ngIf="form.value.rentedToSuite === 0"
                                   class="form-control"
                                   ngModel
                                   name="suiteNumber"
                                   placeholder="Other Unit Number"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.rentedToBuilding && !rentedToSuites.length"></spinner>
                        </div>
                    </div>

                    <!--** rentedToSuiteUser ** -->
                    <div class="row m-b-xs" *ngIf="rentedOutSelect.value == 1">
                        <div class="dv-label col-sm-4 strong">Resident</div>
                        <div class="dv-value col-sm-8">
                            <select class="form-control"
                                    (change)="changeResident($event.target.value)"
                                    ngModel
                                    name="suiteUser"
                                    #residentSelect
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">
                                    {{resident.fullName}}
                                </option>
                            </select>
                            <input *ngIf="residentSelect.value === '0'"
                                   class="form-control"
                                   placeholder="Other Resident Name"
                                   ngModel
                                   name="suiteUserName"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.rentedToSuite && !residents.length"></spinner>
                        </div>
                    </div>

                    <!--  ** Garage Remote **  -->
                    <div class="row m-b-xs ">
                        <div class="dv-label col-sm-4 strong">Garage Remote</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="garageRemote" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--  ** Handicap **  -->
                    <div class="row m-b-xs ">
                        <div class="dv-label col-sm-4 strong">Handicap</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="handicap" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--  ** Legal Description **  -->
                    <div class="row m-b-xs ">
                        <div class="dv-label col-sm-4 strong">Legal Description</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="legalDescription" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--  ** Notes **  -->
                    <div class="row m-b-xs ">
                        <div class="dv-label col-sm-4 strong">Notes: </div>
                        <div class="dv-value-edit col-sm-8">
                            <textarea class="form-control" name="note" ngModel maxlength="255"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="onClose(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/parking-spot-create/parking-spot-create.component.html